import api from "./core";
const config = require("./serverCfg").default;

const basePath = "api/core/ScheduleEvent";

export default {
  get(id, extraHeaders = {}) {
    return api.get(`${basePath}/${id}`, extraHeaders);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  delete(id, deleteRelatedDocuments = false) {
    return api.delete(`${basePath}/${id}/${deleteRelatedDocuments}`);
  },
  query(filter) {
    return api.post(`${basePath}`, filter);
  },
  queryPaginated(filter) {
    return api.post(`${basePath}/GetAllPaginated`, filter);
  },
  queryPaginatedImproved(filter) {
    return api.post(`${basePath}/GetAllPaginatedImproved`, filter);
  },
  create(data) {
    return api.put(`${basePath}`, data);
  },
  setStatus(id, data) {
    return api.patch(`${basePath}/SetStatus/${id}`, data);
  },
  getCostVariations(id, data) {
    return api.patch(`${basePath}/GetCostVariations/${id}`, data);
  },
  setCheckedIn(id, data) {
    return api.patch(`${basePath}/SetCheckedIn/${id}`, data);
  },
  placeClientInGroups(data) {
    return api.patch(`${basePath}/AddParticipants`, data);
  },
  groupSessionViewUrl(documentId) {
    return {
      url: `${config.coreBaseUrl}${basePath}/RenderGroupSession/${documentId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config.token}`
      }
    };
  },
  groupSessionDocumentViewUrl(documentId) {
    return {
      url: `${config.coreBaseUrl}${basePath}/RenderGroupProgressNoteDocument/${documentId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config.token}`
      }
    };
  },
  downloadGroupSessionPdf(ids) {
    return fetch(`${config.coreBaseUrl}${basePath}/DownloadGroupSessionPdf`, {
      method: "POST",
      body: JSON.stringify(ids),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config.token}`
      }
    });
  },
  sendGroupSessionPdf(data) {
    return fetch(`${config.coreBaseUrl}${basePath}/SendGroupSessionPdf`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config.token}`
      }
    });
  },
  getByEocAndType(eocId, type) {
    return api.get(`${basePath}/GetByEocAndType/${eocId}/${type}`);
  },
  createMultiple(data) {
    return api.put(`${basePath}/Multiple`, data);
  },
  updateDates(id, data) {
    return api.patch(`${basePath}/UpdateDates/${id}`, data);
  },
  deleteForm(id) {
    return api.delete(`${basePath}/${id}/forms`);
  },
  attachForm(id, formId) {
    return fetch(`${config.coreBaseUrl}${basePath}/${id}/forms`, {
      method: "POST",
      body: JSON.stringify(formId),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config.token}`
      }
    });
  },
  attachDocuments(id, docIds) {
    return fetch(`${config.coreBaseUrl}${basePath}/${id}/documents`, {
      method: "POST",
      body: JSON.stringify(docIds),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config.token}`
      }
    });
  },
  updateServices(id, data) {
    return api.patch(`${basePath}/UpdateServices/${id}`, { services: data });
  },
  checkForDoubleBookedEvent(data) {
    return api.post(`${basePath}/CheckForDoubleBooking`, data);
  },
  checkForDoubleBookedEventEoc(data) {
    return api.post(`${basePath}/CheckForDoubleBookingEoc`, data);
  },
  resendInvitation(id, eocId) {
    return api.post(`${basePath}/ResendInvitation/${id}/${eocId}`);
  },
  getNextAppointment(eocId) {
    return api.get(`${basePath}/NextAppointment/${eocId}`);
  },
  getNextAppointmentsForSummary(eocId) {
    return api.get(`${basePath}/NextAppointmentsForSummary/${eocId}`);
  },
  sendToPortal(tenantName, scheduleEventId, signalRAppUrl) {
    return fetch(
      `${signalRAppUrl}/api/signalr/appointments/SendAppointmentUpdateSignalToPortalApp/${tenantName}/${scheduleEventId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${config.token}`
        }
      }
    );
  },
  findMinimal(id) {
    return api.get(`${basePath}/FindMinimal/${id}`);
  },
  calculateNumberOfUnitByApptDuration(
    startDateTime,
    endDateTime,
    status,
    serviceIds
  ) {
    return api.patch(
      `${basePath}/Calculate/${startDateTime}/${endDateTime}/${status}`,
      serviceIds
    );
  },
  getEventsByEoc(eocId) {
    return api.get(`${basePath}/GetEventsByEoc/${eocId}`);
  }
};
